module.exports = __webpack_public_path__ + "static/media/logo.033ed004.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo/logo.svg
// module id = 189
// module chunks = 0